<template>
  <router-link
    :to="`${routePaths.categories}/${category.url}`"
    class="category-list-area__item"
  >
    <figure>
      <img
        ref="itemImages"
        :src="require(`@/assets/categories/${category.url}.png`)"
      />
    </figure>

    <caption
      v-html="$t(`LandingPage.${category.title}`).replace(/(?:\r\n|\r|\n)/g, '<br/>') "
    >
      <!-- {{
        $t(`LandingPage.${category.title}`).replace(/(?:\r\n|\r|\n)/g, '<br/>')
      }} -->
    </caption>
  </router-link>
</template>

<script>
import { routePaths } from "@/models/RoutePath";
import objectFitImages from "object-fit-images";
import ResizeText from 'vue-resize-text';

export default {
  directives: {
    ResizeText
 },
  props: {
    category: {
      type: Object,
    },
     
  },

  data() {
    return {
      routePaths,
    };
  },
  mounted() {
    this.$nextTick(() => {
      objectFitImages([this.$refs.itemImages]);
    });
    
  },
};
</script>

<style scoped>
.category-list-area__item {
  max-width: 360px;
  margin-right: 60px;
  display: block;
  width: 22vw;
  background-color: #d6d6d6;
  color: #000;
  padding: 34.5px 0;
  border-radius: 30px;
  cursor: pointer;
}
.category-list-area__item figure {
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* .category-list-area__item img {
  top: 50%;
} */
.category-list-area__item caption {
  margin-top: 45px;
  font-size: 1.8rem;
  font-weight: 700;
  width: 100%;
  display: inline-block;
  /* white-space:nowrap; */
}
@media (max-width: 1200px) {
  .category-list-area__item {
    width: 25vw;
  }
}

@media (max-width: 1100px) {
  .category-list-area__item {
    margin-right: 30px;
    width: 25vw;
  }
  .category-list-area__item caption {
    font-size: 1.4rem;
  }
}
@media (max-width: 767px) {
  .category-list-area__item {
    border-radius: 20px;
  }

  .category-list-area__item figure {
    width: 128px;
    height: 130px;
    margin: auto;
  }

  .category-list-area__item img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .category-list-area__item {
    width: 204px;
  }
}
@media (max-width: 499px) {
  .category-list-area__item {
    width: 50vw;
    height:100%;
  }
  .category-list-area__item caption {
    display:inline-block;
    margin-top: 30px;
    font-size: 1.3rem;
  }
}
@media (min-width: 768px) {
  .category-list-area__item figure {
    height: 19.3vw;
  }
  .category-list-area__item img {
    width: 100%;
    height: 19.3vw;
    max-height: 250px;
    display: inline-block;
    object-fit: contain;
    font-family: "object-fit: contain;";
  }
}

@media (min-width: 1024px) {
  .category-list-area__item figure {
    height: 250px;
    /* width: 290px; */
  }
  .category-list-area__item img {
    width: 100%;
    /* height: 19.3vw; */
    /* max-height: 250px; */
    max-width: 100%;
    display: inline-block;
    object-fit: contain;
  }
  .category-list-area__button.route-button {
    width: 881px;
    box-sizing: border-box;
    font-size: 24px;
  }
}
</style>
